import toast from 'react-hot-toast';

import { clearTriggeredAlerts } from '../../redux/features/uiSlice.ts';
import { store } from '../../redux/store.ts';

const alertToastIds = new Set<string>();

export const registerAlertToast = (id: string) => {
  alertToastIds.add(id);
};

export const dismissAllToasts = () => {
  toast.dismiss();
};

export const dismissAlertToasts = () => {
  alertToastIds.forEach((toastId) => toast.dismiss(toastId));
  alertToastIds.clear();
  store.dispatch(clearTriggeredAlerts());
};
